import { getTransactionsPageNumberInString } from "./TransactionsUtils";

import { sendRequest } from "@/utils/ApiUtil";

const fetchTransactions = async (
  id: string,
  page: number,
  pageSize: number,
  startDate?: Date,
  endDate?: Date
) => {
  try {
    const data: any = {
      accountId: id,
      page,
      pageSize,
      order: "ASC",
    };

    if (startDate) {
      const startDateFormatted = startDate.toISOString().split("T")[0];
      data.startDate = startDateFormatted;
    }
    if (endDate) {
      const endDateFormatted = endDate.toISOString().split("T")[0];
      data.endDate = endDateFormatted;
    }

    const request = await sendRequest("get", "/transactions", data, true);
    return request;
  } catch (error: any) {
    console.log(error);
  }
};

export async function getTransactions(
  accountId: string,
  page: number,
  pageSize: number,
  startDate?: Date,
  endDate?: Date
): Promise<{ transactions: any[]; error: boolean }> {
  const transactionsList: any[] = [];
  let errorOccurred = false;
  let currentPage: number = page;
  let nextPage: number = 1;

  try {
    const firstGetTransactions = await fetchTransactions(
      accountId,
      page,
      pageSize,
      startDate,
      endDate
    );

    nextPage = getTransactionsPageNumberInString(
      firstGetTransactions.links?.next
    );

    transactionsList.push(
      ...firstGetTransactions.scheduledTransactions,
      ...firstGetTransactions.transactions
    );

    if (nextPage === currentPage) {
      return { transactions: transactionsList, error: false };
    }

    while (nextPage !== currentPage) {
      let attempts = 0;
      let page = nextPage;
      const maxAttempts = 5;
      let success = false;

      while (attempts < maxAttempts) {
        try {
          const response = await fetchTransactions(
            accountId,
            page,
            pageSize,
            startDate,
            endDate
          );

          transactionsList.push(...response.transactions);

          nextPage = getTransactionsPageNumberInString(response.links?.next);
          success = true;
          page++;
          currentPage++;
          break;
        } catch (err) {
          attempts++;
          console.error(
            `Erro na requisição da página ${currentPage}, tentativa ${attempts} de ${maxAttempts}`,
            err
          );
          if (attempts >= maxAttempts) {
            errorOccurred = true;
            break;
          }
        }
      }

      if (!success || errorOccurred) {
        break;
      }
    }

    return { transactions: transactionsList, error: errorOccurred };
  } catch (error: any) {
    console.error("Erro ao buscar transações:", error);
    return { transactions: [], error: true };
  }
}

export function filterUniqueTransactions(
  transactions: any[],
  globalTransactions: any[]
) {
  const globalMap = new Map(globalTransactions.map((tx) => [tx.id, tx]));
  const resultMap = new Map(globalMap);

  for (const tx of transactions) {
    if (!tx || !tx.id) continue;

    const existingTransaction = globalMap.get(tx.id);

    if (existingTransaction) {
      if (existingTransaction.hasOwnProperty("transactionStatus")) {
        if (existingTransaction.transactionStatus !== tx.transactionStatus) {
          resultMap.set(tx.id, {
            ...existingTransaction,
            transactionStatus: tx.transactionStatus,
          });
        }
      } else if (existingTransaction.hasOwnProperty("status")) {
        if (existingTransaction.status !== tx.status) {
          resultMap.set(tx.id, {
            ...existingTransaction,
            status: tx.status,
          });
        }
      }
    } else {
      resultMap.set(tx.id, tx);
    }
  }

  return Array.from(resultMap.values());
}
